import { useFormContext } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { InputField } from 'lib/iterable-hook-form/FormField';
import { EMAIL, FIRST_NAME, LAST_NAME } from '../constants';
import { FormSection } from './FormSection';
import type { NewOrganizationFormSchemaType } from '../contexts/NewOrganizationFormProvider';

export const TEXT = {
  HEADING: 'Administrator',
  DESCRIPTION:
    'This person will have admin access to all of of the organization’s projects. Note the same email address can’t be used as the administrator for multiple organizations.',
  FIRST_NAME_LABEL: 'First name',
  LAST_NAME_LABEL: 'Last name',
  EMAIL: 'Email',
};

export const AdministratorFormSection = () => {
  const {
    formState: { errors },
  } = useFormContext<NewOrganizationFormSchemaType>();

  const emailError = errors.email?.message;
  const firstNameError = errors.firstName?.message;
  const lastNameError = errors.lastName?.message;

  return (
    <FormSection id="administrator" headingText={TEXT.HEADING} descriptionText={TEXT.DESCRIPTION}>
      <FormField
        labelText={TEXT.FIRST_NAME_LABEL}
        errorText={firstNameError}
        hasError={!!firstNameError}
        inputId={FIRST_NAME}
        isHorizontalLayout
      >
        <InputField id={FIRST_NAME} name={FIRST_NAME} />
      </FormField>

      <FormField
        labelText={TEXT.LAST_NAME_LABEL}
        errorText={lastNameError}
        hasError={!!lastNameError}
        inputId={LAST_NAME}
        isHorizontalLayout
      >
        <InputField id={LAST_NAME} name={LAST_NAME} />
      </FormField>

      <FormField
        labelText={TEXT.EMAIL}
        errorText={emailError}
        hasError={!!emailError}
        inputId={EMAIL}
        isHorizontalLayout
      >
        <InputField id={EMAIL} name={EMAIL} />
      </FormField>
    </FormSection>
  );
};
